module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/area_map-190160d0663554224a63e1a5179d83b9.png";